/* eslint-disable sort-keys, perfectionist/sort-objects */
import {
  JobListingDatePostedEnum,
  JobListingEducationLevelEnum,
  JobListingEmploymentTypeEnum,
  JobListingExperienceLevelEnum,
  JobListingPayPeriodEnum,
  JobListingWorkArrangementEnum,
} from '@gql/graphql'

export const employmentTypeOptions: Record<JobListingEmploymentTypeEnum, string> = {
  [JobListingEmploymentTypeEnum.FullTime]: 'Full Time',
  [JobListingEmploymentTypeEnum.PartTime]: 'Part Time',
  [JobListingEmploymentTypeEnum.Intern]: 'Intern',
  [JobListingEmploymentTypeEnum.Contractor]: 'Contract',
  [JobListingEmploymentTypeEnum.PerDiem]: 'Per Diem',
  [JobListingEmploymentTypeEnum.Temporary]: 'Temporary',
  [JobListingEmploymentTypeEnum.Volunteer]: 'Volunteer',
  [JobListingEmploymentTypeEnum.Other]: 'Other',
}

export const payPeriodOptions: Record<JobListingPayPeriodEnum, string> = {
  [JobListingPayPeriodEnum.Day]: 'Daily',
  [JobListingPayPeriodEnum.Hour]: 'Hourly',
  [JobListingPayPeriodEnum.Month]: 'Monthly',
  [JobListingPayPeriodEnum.Week]: 'Weekly',
  [JobListingPayPeriodEnum.Year]: 'Yearly',
}

export const workArrangementOptions: Record<JobListingWorkArrangementEnum, string> = {
  [JobListingWorkArrangementEnum.Hybrid]: 'Hybrid',
  [JobListingWorkArrangementEnum.OnSite]: 'On-Site',
  [JobListingWorkArrangementEnum.RemoteOk]: 'Remote OK',
  [JobListingWorkArrangementEnum.RemoteSolely]: 'Remote Only',
}

export const experienceLevelOptions: Record<JobListingExperienceLevelEnum, string> = {
  [JobListingExperienceLevelEnum.InternshipLevel]: 'Internship Level',
  [JobListingExperienceLevelEnum.EntryLevel]: 'Entry Level',
  [JobListingExperienceLevelEnum.MidLevel]: 'Mid Level',
  [JobListingExperienceLevelEnum.SeniorLevel]: 'Senior Level',
  [JobListingExperienceLevelEnum.DirectorLevel]: 'Director Level',
  [JobListingExperienceLevelEnum.ExecutiveLevel]: 'Executive Level',
}

export const datePostedOptions: Record<JobListingDatePostedEnum, string> = {
  [JobListingDatePostedEnum.Last_1Day]: 'Past 24 hours',
  [JobListingDatePostedEnum.Last_7Days]: 'Past 7 days',
  [JobListingDatePostedEnum.Last_14Days]: 'Past 14 days',
  [JobListingDatePostedEnum.Last_30Days]: 'Past 30 days',
}

export const educationLevelOptions: Record<JobListingEducationLevelEnum, string> = {
  [JobListingEducationLevelEnum.HighSchool]: 'High School',
  [JobListingEducationLevelEnum.AssociateDegree]: 'Associate Degree',
  [JobListingEducationLevelEnum.BachelorDegree]: 'Bachelor Degree',
  [JobListingEducationLevelEnum.PostgraduateDegree]: 'Postgraduate Degree',
  [JobListingEducationLevelEnum.ProfessionalCertificate]: 'Professional Certificate',
}
